import * as React from "react";
import IntercomRoot from "react-intercom";

import { UserInfoQuery } from "modules/Dashboard/UserInfo";
import { getIntercomProps } from "utilities/intercom";
import { Mobile } from "components/Layout/Responsive";

export const intercomSelector = "intercom-launcher";

export default function Intercom({ me }: { me: UserInfoQuery["userInfo"]["me"] }) {
  const canUseIntercom = me?.organizationUser?.canSelfAssign && me?.organizationUser?.canRequest;

  if (!me || !canUseIntercom) return null;

  return (
    <Mobile>
      {isMobile => (
        <IntercomRoot
          {...getIntercomProps(me, {
            customSelector: "." + intercomSelector,
            hideDefaultLauncher: isMobile,
          })}
        />
      )}
    </Mobile>
  );
}
